<template>
  <div class="switch-input" :class="{ disabled: disabled }">
    <button
      type="button"
      class="switch-button"
      :class="{ active: modelValue }"
      :disabled="disabled"
      @click="toggle"
      role="switch"
      :aria-checked="modelValue"
    >
      <span class="switch-slider"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SwitchInput',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue);
      }
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.switch-input {
  display: inline-block;
}

.switch-button {
  position: relative;
  width: 40px;
  height: 22px;
  background-color: #d1d5db;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 0;
}

.switch-button:hover:not(:disabled) {
  background-color: #9ca3af;
}

.switch-button.active {
  background-color: var(--primary-color);
}

.switch-button.active:hover:not(:disabled) {
  background-color: var(--primary-hover);
}

.switch-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.switch-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: var(--border-radius);
  transition: transform 0.2s ease;
}

.switch-button.active .switch-slider {
  transform: translateX(18px);
}

.switch-input.disabled {
  opacity: 0.6;
}
</style>
